/* eslint-disable max-len */
// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class KidneyIcon extends PureComponent {
  
  static propTypes = {
    color: PropTypes.string,
  }
  static defaultProps = {
    color: '#ED6047',
  }
  
  render() {
    const { color } = this.props;
    
    return (
      <svg
        x="0px"
        y="0px"
        height="100%"
        viewBox="0 0 272.728 216.667"
        enableBackground="new 0 0 272.728 216.667"
        xmlSpace="preserve">
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill={ color }
            d="M133.212,11.163c0,30.333,0,60.667,0,91
              c10.191,12.768,36.617,13.646,59,11c-0.694,13.64-23.449,8.276-35,8c-2.988,23.012,0.985,52.985-2,76c-3.61,2.585-9.121,2.031-13,0
              c-2.299-25.035-0.359-54.308-1-81c-3.072-0.261-4.497-2.17-7-3c-2.991,25.676,0.988,58.321-2,84c-3.281,2.17-7.7,2.268-12,1
              c-4.546-22.787-0.755-53.911-2-80c-8.874,1.802-30.704,11.802-34-2c13.656-1.011,29.296-0.037,34-10
              c-8.217-0.204-23.182,6.805-35,3c-0.725-9.087,10.514-5.973,17-7c6.998-1.108,13.361-3.503,18-5c0.658-28.342-1.322-59.322,1-86
              C121.393,7.732,130.78,8.842,133.212,11.163z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd" fill={ color }
            d="M156.212,11.163c0,26.333,0,52.667,0,79
              c7.145,6.855,27.428,0.572,32,10c-7.94,4.285-23.246,1.28-31-1c-2.236,0.431-0.405,4.929-1,7c-5.848-2.151-11.347-4.653-15-9
              c0-28.333,0-56.667,0-85C143.288,8.262,152.927,8.148,156.212,11.163z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd" fill={ color }
            d="M67.212,37.163c18.715-3.236,36.974,7.897,37,29
              c0.032,26.019-27.53,26.684-29,43c-1.716,19.043,25.524,22.1,26,46c0.623,31.25-37.092,37.626-59,20
              C0.342,141.474,7.37,47.511,67.212,37.163z M62.212,55.163C85.574,58.837,58.208,31.302,62.212,55.163L62.212,55.163z
              M50.212,54.163c-9.175,10.664-25.84,23.926-21,42c1.667,0,3.333,0,5,0c4.756-6.698,6.691-13.529,11-20
              c4.145-6.224,10.117-10.901,13-18C56.8,55.575,54.98,53.394,50.212,54.163z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd" fill={ color }
            d="M195.212,37.163c34.117-6.701,61.826,32.195,65,62
              c3.027,28.419-7.373,57.365-24,73c-7.604,7.149-21.214,15.084-35,14c-28.789-2.264-32.999-37.563-15-56
              c4.619-4.731,13.924-8.135,14-19c0.154-21.813-40.307-23.022-27-57C176.681,45.305,184.644,39.239,195.212,37.163z M200.212,56.163
              c7.205-2.27,16.771,4.235,16-5c-0.885-10.59-24.182-6.01-30,2c-3.589,4.939-4.587,11.059-4,18c3.923,0.926,3.717,2.178,8,1
              C194.315,65.084,191.804,58.81,200.212,56.163z M230.212,53.163c-15.734-6.94-8.721,18.69,1,7
              C231.792,56.917,230.53,55.51,230.212,53.163z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFFFFF"
            d="M62.212,55.163C58.208,31.302,85.574,58.837,62.212,55.163L62.212,55.163z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFFFFF"
            d="M190.212,72.163c-4.283,1.178-4.077-0.074-8-1
              c-0.587-6.941,0.411-13.061,4-18c5.818-8.01,29.115-12.59,30-2c0.771,9.235-8.795,2.73-16,5
              C191.804,58.81,194.315,65.084,190.212,72.163z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFFFFF"
            d="M231.212,60.163c-9.721,11.69-16.734-13.94-1-7C230.53,55.51,231.792,56.917,231.212,60.163z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFFFFF"
            d="M58.212,58.163c-2.883,7.099-8.855,11.776-13,18
              c-4.309,6.471-6.244,13.302-11,20c-1.667,0-3.333,0-5,0c-4.84-18.074,11.825-31.336,21-42C54.98,53.394,56.8,55.575,58.212,58.163z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/KidneyIcon/index.jsx